import { TextLayer, IconLayer } from '@deck.gl/layers/typed'

import measurer from '../assets/img/measurer.png'
import { LAYER_NAME } from './config'
import { PainterModel } from './domain/painter.model'

/* Слой с иконкой линейки под кругом */
export const computeMeasureIconLayer = (
  painter: PainterModel
): IconLayer | null => {
  return new IconLayer({
    id: LAYER_NAME.MEASURE_ICON,
    data: [{ coordinates: [painter.coordinates[0], painter.coordinates[1]] }],
    iconAtlas: measurer,
    iconmapApiping: { marker: { x: 0, y: 0, width: 174, height: 48 } },
    getIcon: () => 'marker',
    sizeScale: 16,
    getPixelOffset: [0, 52],
    getColor: () => [255, 255, 255, 255],
    getPosition: (d) => d.coordinates
  })
}

/** Генерирует слой с иконкой рядом с кол-вом найденных пользователей в области поиска */
export const computeFoundUsersInAreaIconLayer = (
  painter: PainterModel,
  usersCount: number | null,
  currentZoom: number
): TextLayer | null => {
  return new TextLayer({
    id: LAYER_NAME.USERS_ICON,
    data: [
      {
        coordinates: [painter.coordinates[1], painter.coordinates[0]],
        radius: painter.radius,
        zoom: currentZoom
      }
    ],
    getPosition: (d: PainterModel) => d.coordinates,
    characterSet: ['\ue7fd'],
    getText: () => '\ue7fd',
    getSize: () => 24,
    visible: currentZoom > 14,
    getTextAnchor: 'middle',
    getPixelOffset: () => {
      if (!usersCount) {
        return [-20, 4]
      }
      if (usersCount < 1000) {
        return [-28, 4]
      }
      if (usersCount > 1000) {
        return [-36, 4]
      }
      if (usersCount > 10000) {
        return [-44, 4]
      }
      return [-32, 4]
    },
    getColor: () => [0, 0, 0, 200],
    getAlignmentBaseline: 'center',
    fontFamily: 'Material Icons'
  })
}

type RadiusDataType = {
  coordinates: number[]
  radius: number
}
/* Слой с подписью радиуса круга области поиска */
export const computeAreaRadiusLayer = (
  painter: PainterModel,
  currentZoom: number
): TextLayer | null => {
  return new TextLayer({
    id: LAYER_NAME.CIRCLE_RADIUS,
    data: [
      {
        coordinates: [painter.coordinates[1], painter.coordinates[0]],
        radius: painter.radius,
        zoom: currentZoom
      }
    ],
    getPosition: (d: PainterModel) => d.coordinates,
    getText: (d: RadiusDataType) => {
      return `${Math.floor(d.radius)} m`
    },
    visible: currentZoom > 14,
    getSize: () => 24,
    getColor: () => [0, 0, 0, 200],
    getPixelOffset: [0, 22],
    fontFamily: 'Calibri',
    fontWeight: 'bold'
  })
}

/* Слой для отображения количества найденных пользователей в центре области поиска */
export const computeCircleUserCountLayer = (
  painter: PainterModel,
  foundUsersCount: number,
  currentZoom: number
): TextLayer | null => {
  return new TextLayer({
    id: LAYER_NAME.USERS_COUNT,
    data: [
      {
        coordinates: [painter.coordinates[1], painter.coordinates[0]],
        radius: painter.radius,
        zoom: currentZoom
      }
    ],
    visible: currentZoom > 12,
    getPosition: (d) => d.coordinates,
    getText: () => (foundUsersCount ? foundUsersCount.toString() : '...'),
    getSize: () => (currentZoom > 14 ? 24 : 12),
    getColor: () => [0, 0, 0, 200],
    fontFamily: 'Calibri',
    fontWeight: 'bold'
  })
}
